import React from 'react';
import Us1_mid_sub from './us1_mid_sub';

const Us1_mid = () => {
  return (
    <div>
    <Us1_mid_sub />  
    </div>
  );
}

export default Us1_mid;
